import { faLuggageCart, faTimes, faTrailer } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Col, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { keyIsLetterOrNumber, setErrorDialog } from "../../store/api/CommonFunctions";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { useEffect, useRef, useState } from "react";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import { useDispatch, useSelector } from "react-redux";
import { CheckLg, DashCircle, ExclamationTriangle, List, Pencil, PlusSquareFill } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import { loadProductAccessories, deleteProductAccessory, addOrUpdateProductAccessory, getAllProductTypes } from "../store/api/GetAllProduct";

const ModalProductAccessories = (props) => {
    const dispatch = useDispatch();
    const { popData, setPopData } = props;
    const { show } = popData;
    const [dataList, setDataList] = useState(null);
    const systemSettings = useSelector(state => state.SystemSettingsReducer.systemSettings);
    const [popProduct, setPopProduct] = useState({ show: false });
    const [selectedProduct, selectProduct] = useState(null);
    const selectedType = useRef(null);
    const [currentRow, setCurrentRow] = useState(null);
    const [submitError, setSubmitError] = useState(null);
    const [typeList, setTypeList] = useState(null);
    const settingNames = ['ProductGrouppingType'];
    const productGrouppingType = Array.isArray(systemSettings ?? 0) ? Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1) : 1;
    function showModalProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const setData = (data) => {
            if (data) {
                selectProduct(data);
                loadProductAccessories({ ProductID: data.ProductID }, setDataList);
            }
        }
        setPopProduct({ show: true, value: e.key, setProductData: setData });
    }
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "نام لوازم", colName: "AccessoryName", showInMobile: true }
    ]
    const rowButtons = [
        { title: "ویرایش", type: "common", icon: <Pencil color="orange" size={18} />, onclick: selectRow },
        { title: "حذف", type: "delete", onclick: deletePA }
    ]
    function selectRow(row) {
        const { e, target, ...selected } = row;
        setCurrentRow(selected);
    }
    function deletePA(row) {
        const onSuccess = (res) => {
            if (res?.toLowerCase() === "success") {
                dataList.Data = dataList.Data.filter(p => Number(p.ID) !== Number(row.ID));
                setDataList({ ...dataList });
            }
        }
        deleteProductAccessory(row.ID, onSuccess);
    }
    function prepareForAdd() {
        setCurrentRow({ ID: 0 });
    }
    function submitPA() {
        setSubmitError(null);
        const onSuccess = (res) => {
            if (res.Data) {
                if (Number(currentRow.ID) > 0) {
                    const edited = dataList.Data.find(p => Number(p.ID) === Number(currentRow.ID));
                    edited.AccessoryName = currentRow.AccessoryName;
                }
                else {
                    dataList.Data.push({ ...currentRow, ID: res.Data });
                }
                setDataList({ ...dataList });
                setCurrentRow(null);
            }
            else if (res.Error) {
                setSubmitError(res.Error);
            }
        }
        if (selectedProduct?.ProductID) {
            currentRow.ProductID = selectedProduct.ProductID;
        }
        currentRow.ProductTypeID = selectedType.current;
        addOrUpdateProductAccessory(currentRow, onSuccess);
    }
    function cancelPA() {
        setCurrentRow(null);
    }
    function close() {
        setPopData({ show: false });
        setCurrentRow(null);
        selectProduct(null);
        setSubmitError(null);
    }
    function onChangeType(typeId) {
        selectedType.current = typeId;
        loadProductAccessories({ ProductID: -1, ProductTypeID: typeId, DefineMode: true }, setDataList);
    }
    useEffect(() => {
        if (show) {
            const onGetSettings = (res) => {
                if (Array.isArray(res) && res.length > 0) {
                    const pgType = Number(res.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1);
                    if (pgType !== 1)
                        getAllProductTypes(setTypeList);
                }
            }
            dispatch(getSystemSettings(settingNames, onGetSettings));
            loadProductAccessories({ ProductID: -1 }, setDataList);
        }

    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={productGrouppingType} defaultSalePrice={""}
                defaultSalePriceLabel={""} defaultStorages={""} />
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faLuggageCart} size="lg" />&nbsp;
                    لوازم همراه
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={close} size="lg" />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {submitError &&
                    <Alert variant="danger">
                        <span>
                            <ExclamationTriangle size={18} />&nbsp;
                            {submitError}
                        </span>
                        <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setSubmitError(null)} />
                    </Alert>
                }
                {productGrouppingType === 1 ?
                    <FormGroup>
                        <Form.Control onKeyDown={showModalProduct} readOnly value={(selectedProduct?.ProductName ?? "") + "-" + (selectedProduct?.ProductModel ?? "")} />
                        <Button className="btn-input-tiny" onClick={showModalProduct} style={{ top: 3, left: 3 }}><List size={21} /></Button>
                    </FormGroup> :
                    <FormGroup>
                        <select className="form-control" onChange={e => onChangeType(e.target.value)}>
                            <option value="">نوع کالا را انتخاب کنید</option>
                            {Array.isArray(typeList ?? "") &&
                                typeList.map((t, i) => <option value={t.ID} key={i}>{t.Name}</option>)
                            }
                        </select>
                    </FormGroup>
                }
                {currentRow ?
                    <Row className="rowBorder mt-2 mb-1">
                        <FormGroup>
                            <Form.Control defaultValue={currentRow.AccessoryName ?? ""} onChange={e => currentRow.AccessoryName = e.target.value} style={{ width: "70%", display: "inline-block" }} />
                            <Button className="group-Btn-smalll" variant="success"><CheckLg size={16} onClick={submitPA} />&nbsp;</Button>
                            <Button className="group-Btn-smalll" variant="danger" onClick={cancelPA}><DashCircle size={16} /></Button>
                        </FormGroup>
                    </Row> :
                    <PlusSquareFill color="#006f80" size={25} className="mt-1 mb-1 hoverIcon" onClick={prepareForAdd} />
                }
                <BihamtaTable columns={tableCols} rowButtons={rowButtons} dataList={dataList} maxHeight={500} className="mt-0" rowClick={selectRow} />
            </Modal.Body>
        </Modal>
    )
}
export default ModalProductAccessories;